var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('checkbox-component',{staticClass:"align-items-start news-checkbox",attrs:{"id":_vm.name},on:{"checkbox:change":_vm.onChange}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('Receive news', {name: _vm.channelName}))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }